import { render, staticRenderFns } from "./peremployee.vue?vue&type=template&id=5a3ef579&scoped=true"
import script from "./peremployee.vue?vue&type=script&lang=js"
export * from "./peremployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3ef579",
  null
  
)

export default component.exports